// removed by extract-text-webpack-plugin
module.exports = {"services-container":"ServicesPanel__services-container___2mtab","other-services-button":"ServicesPanel__other-services-button___2U9YN"};